import { render, staticRenderFns } from "./CardTexto.vue?vue&type=template&id=ff19d1ee&scoped=true&"
import script from "./CardTexto.vue?vue&type=script&lang=js&"
export * from "./CardTexto.vue?vue&type=script&lang=js&"
import style0 from "./CardTexto.vue?vue&type=style&index=0&id=ff19d1ee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff19d1ee",
  null
  
)

export default component.exports